// ABOUTME: UI component for SharePoint field action buttons (Browse and Clear)
// ABOUTME: Handles Browse SharePoint and Clear Selection actions with proper state management
/* eslint-disable react/prop-types */

import { Button, FolderOpenOutlinedIcon, Stack } from '@ds/coolshop';
import React from 'react';
import { useIntl } from 'react-intl';

import type { ISharePointItem } from '../api/types';

type IActionButtonsProps = {
    readonly selectedFile: ISharePointItem | null;
    readonly onBrowse: () => void;
    readonly onClear: () => void;
    readonly disabled?: boolean;
    readonly readOnly?: boolean;
};

export const ActionButtons: React.FC<IActionButtonsProps> = React.memo(
    ({ selectedFile, onBrowse, onClear, disabled = false, readOnly = false }) => {
        const intl = useIntl();

        return (
            <Stack direction="row" justifyContent="center" gap={2}>
                <Button
                    variant="contained"
                    startIcon={<FolderOpenOutlinedIcon />}
                    size="small"
                    onClick={onBrowse}
                    disabled={disabled || readOnly}
                >
                    {selectedFile
                        ? intl.formatMessage({
                              id: 'sharepoint.change-file',
                              defaultMessage: 'Cambia File',
                          })
                        : intl.formatMessage({
                              id: 'sharepoint.browse-sharepoint',
                              defaultMessage: 'Sfoglia SharePoint',
                          })}
                </Button>

                {selectedFile && !disabled && !readOnly && (
                    <Button onClick={onClear} size="small">
                        {intl.formatMessage({
                            id: 'sharepoint.clear-selection',
                            defaultMessage: 'Cancella Selezione',
                        })}
                    </Button>
                )}
            </Stack>
        );
    },
);

ActionButtons.displayName = 'ActionButtons';
